import React, { useState } from "react";
import { Box, Typography } from "@mui/material";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";

const ImageUpload = ({
  width = "100%",
  height = "200px",
  backgroundColor = "#f0f0f0",
  labelText = "Upload an image",
}) => {
  const [imageUrl, setImageUrl] = useState(null);

  // Handle the drop event for drag-and-drop
  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (file) {
      readFile(file);
    }
  };

  // Handle file selection from the input
  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      readFile(file);
    }
  };

  // Read the file and set the image URL
  const readFile = (file) => {
    const reader = new FileReader();
    reader.onloadend = () => {
      setImageUrl(reader.result);
    };
    reader.readAsDataURL(file);
  };

  // Function to trigger the file input click
  const handleBoxClick = () => {
    document.getElementById("file-upload").click();
  };

  return (
    <Box
      width={width}
      height={height}
      bgcolor={backgroundColor}
      onDragOver={(e) => e.preventDefault()} // Prevent default behavior
      onDrop={handleDrop} // Handle drop event
      position="relative"
      onClick={handleBoxClick} // Trigger file input on box click
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ cursor: "pointer" }} // Change cursor to pointer
    >
      {imageUrl ? (
        <Box position="absolute" height={height} width={width}>
          <img
            alt="Uploaded file"
            src={imageUrl}
            style={{
              height: "100%",
              width: "100%",
              objectFit: "cover",
            }}
          />
        </Box>
      ) : (
        <>
          <CloudUploadIcon fontSize="large" />
          <Typography variant="body2" color="primary">
            {labelText}
          </Typography>
        </>
      )}
      <input
        type="file"
        accept="image/*" // Accept only images
        onChange={handleFileChange} // Handle file selection
        style={{ display: "none" }} // Hide the default file input
        id="file-upload"
        name="image"
      />
    </Box>
  );
};

export default ImageUpload;
